<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>用户信息</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="primary" class="ml-3"
             @click.native.stop="() => { editDbid = 'self'; edit = true; }">
        <v-icon dark small>edit</v-icon>修改用户信息
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <div class="x-text-field">
              <label>用户名</label>
              <div>{{item.username}}</div>
            </div>
          </v-flex>

          <v-flex xs12>
            <div class="x-text-field">
              <label>姓名</label>
              <div>{{item.name}}</div>
            </div>
          </v-flex>

          <v-flex xs12>
            <div class="x-text-field">
              <label>工号</label>
              <div>{{item.number}}</div>
            </div>
          </v-flex>

          <v-flex xs12>
            <div class="x-text-field">
              <label>电子邮箱</label>
              <div>{{item.email}}</div>
            </div>
          </v-flex>

          <v-flex xs12>
            <div class="x-text-field">
              <label>部门及角色</label>
              <div>
                {{item.deptRoles ? item.deptRoles.map(dr => `${dr.department.name}（${dr.role.name}）`).join(', '): ''}}
              </div>
            </div>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="(v) => {item = v || item; editDbid = null;}"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XEdit from './Edit'

  const baseUri = '/api/syst/user/self';

  export default {
    components: {XEdit},

    data() {
      return {
        uri: baseUri,

        item: {},

        edit: false,
        editDbid: null
      }
    },

    created() {
      this.axios.get(baseUri).then(rsp => {
        this.item = rsp.data;
      })
    },

    computed: {
      ...mapGetters(['userId'])
    },

    methods: {}
  }
</script>
